import React from 'react';

import FieldText from '../common/FieldText';
import FieldDecimal from '../common/FieldDecimal';

class PropertyPricingInfo extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Property Pricing</h2></div>

        <FieldText key="carpet_area" id="carpet_area" field={fields.carpet_area}
          value={property.carpet_area} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="build_area" id="build_area" field={fields.build_area}
          value={property.build_area} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="price" id="price" field={fields.price}
          value={property.price} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="price_per_sqft" id="price_per_sqft" field={fields.price_per_sqft}
          value={property.price_per_sqft} onValueChange={onValueChange} inValid={inValid} />
  
        <FieldDecimal key="deposit" id="deposit" field={fields.deposit}
          value={property.deposit} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="agreement_price" id="agreement_price" field={fields.agreement_price}
          value={property.agreement_price} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="developement_charge" id="developement_charge" field={fields.developement_charge}
          value={property.developement_charge} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="parking_charges" id="parking_charges" field={fields.parking_charges}
          value={property.parking_charges} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="society_charges" id="society_charges" field={fields.society_charges}
          value={property.society_charges} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="other_charges" id="other_charges" field={fields.other_charges}
          value={property.other_charges} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="stamp_duty" id="stamp_duty" field={fields.stamp_duty}
          value={property.stamp_duty} onValueChange={onValueChange} inValid={inValid} />

        <FieldDecimal key="registration" id="registration" field={fields.registration}
          value={property.registration} onValueChange={onValueChange} inValid={inValid} />

        
        <br/>
      </>
    );
  }
}

export default PropertyPricingInfo;